import React, { useEffect, useState } from 'react';
import { Page, Document, Image, StyleSheet, Text } from '@react-pdf/renderer';
import OrderServiceHead from './OrderServiceHead';
import OrderServiceDescription from './OrderServiceDescription';
import OrderServiceItemsTable from './OrderServiceItemsTable';
import OrderServiceTimeControl from './OrderServiceTimeControl';
import OrderServiceFooter from './OrderServiceFooter';
import OrderServiceSuppliesTable from './OrderServiceSuppliesTable';
import OrderServiceTasksTable from './OrderServiceTasksTable';

import apiAccountCustumer from '@iso/services/repository/accountCustumer';
import apiFiles from '@iso/services/repository/files';

let employeLogoDimensions = [65,65];
const image = sessionStorage.getItem('employeLogo');

if(image !== null && typeof image !== 'undefined')
    employeLogoDimensions = sessionStorage.getItem('employeLogoDimensions').split('x');

const styles = StyleSheet.create({
    page: {
        fontFamily: 'Helvetica',
        fontSize: 11,
        paddingTop: 30,
        paddingLeft:30,
        paddingRight:30,
        lineHeight: 1.5,
        flexDirection: 'column',
    }, 
    logo: {
      marginLeft: '0',
      width: employeLogoDimensions[0], 
      height: employeLogoDimensions[1],
        // marginRight: 'auto'
    },
    reportTitle:{
        color: '#252525',
        letterSpacing: 4,
        fontSize: 16,
        textAlign: 'center',
        marginTop: '-35px',
        marginLeft: '250px',
        textTransform: 'uppercase',
    }
});
  
const OrderService = ({data}) => {
    const [orderserviceData, setOrderServiceData] = useState(data);
    const [ iconAccount, setIconAccount ] = useState([]);

    useEffect(() => {
        apiAccountCustumer
          .getAccountCustumer()
          .then((response) => {
            if(response.data._id){
              if(response.data.icon){
                renderImages(response.data.icon)
              }
            } else {
              console.log(response.data);
            }
          })
          .catch((err) => {
            console.error( err);
          });
    }, []);
    
    function renderImages(images) {
        images.forEach(imag => {
          viwerAnexo('images', imag, 'add_images')
        });
    }
    
    const viwerAnexo = (type, anx) => {
        try {
          apiFiles
            .getAnexos(type, anx._id)
            .then( response => {
                const blob = new Blob([response.data], { type: response.headers.get('content-type')}); 
                setIconAccount(
                    <Image style={styles.logo} src={URL.createObjectURL(blob)}/>
                );
            })
        } catch (error) {
          console.log("arquivo não encontrado")
        }
    }
    return (
        <Document>
            <Page size="A4" style={styles.page}>
                {iconAccount}
                <Text style={styles.reportTitle}>{orderserviceData.title}</Text>
                <OrderServiceHead data={orderserviceData} />
                { 
                    (orderserviceData.type == 'Service') 
                    ? <OrderServiceItemsTable data={orderserviceData} />
                    : 
                    <>
                        <OrderServiceTasksTable data={orderserviceData} />
                        <OrderServiceSuppliesTable data={orderserviceData} />
                    </>
                }
                <OrderServiceTimeControl data={orderserviceData} /> 
                <OrderServiceDescription data={orderserviceData} />
                <OrderServiceFooter data={orderserviceData} />
            </Page>
        </Document>
    )
};
  
export default OrderService